import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
  {
      path: '/',
      redirect: '/login-card'
  }, {
        path: '/login-card',
        component: () => import('@/views/loginCard'),
        name: 'login-card'
    }, {
        path: '/login',
        component: () => import('@/views/login'),
        name: 'login'
    }, {
        path: '/register',
        component: () => import('@/views/register'),
        name: 'register'
    }, {
        path: '/index',
        component: () => import('@/views/indexComponent'),
        redirect: 'index/index',
        children: [{
            path: 'index',
            component: () => import('@/views/index'),
            name: 'index'
        }, {
            path: 'hall',
            component: () => import('@/views/indexHall'),
            name: 'hall'
        }, {
            path: 'create',
            component: () => import('@/views/indexCreate'),
            name: 'create'
        }, {
            path: 'mine',
            component: () => import('@/views/indexMine'),
            name: 'mine'
        }]
    }, {
        path: '/room/:id',
        component: () => import('@/views/room'),
        name: 'room'
    }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
    if (from.name === to.name) {
        return;
    }
    next();
});

export default router
